import { IFlowRunSpecOutputStepViewModel } from '../types/IFlowRunSpecOutputStepViewModel';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface RunFlowOnOutputStepsParams {
  readonly flowId: string;
  readonly flowOutputStepIds: string[];
  readonly flowRunSpecOutputStepParams: IFlowRunSpecOutputStepViewModel[];
}

export interface RunFlowOnOutputStepsResult extends IResult {
}

export class RunFlowOnOutputStepsRequest extends Request<RunFlowOnOutputStepsParams, RunFlowOnOutputStepsResult> {
  constructor(params: RunFlowOnOutputStepsParams) {
    super('runFlowOnOutputSteps', params);
  }
}


